import { useSelector } from '@legendapp/state/react';
import {
  auth$,
  login as storeLogin,
  register as storeRegister,
  logout as storeLogout,
} from '../store';

// --- Auth Hook using Legend State + Supabase Auth ---
const useAuth = () => {
  const user = useSelector(() => auth$.user.get());
  const session = useSelector(() => auth$.session.get());
  const isAuthenticated = useSelector(() => auth$.isAuthenticated.get());
  const isLoading = useSelector(() => auth$.isLoading.get());

  const login = async (usernameOrEmail, password) => {
    return storeLogin(usernameOrEmail, password);
  };

  const register = async (email, username, password, lang) => {
    return storeRegister(email, username, password, lang);
  };

  const logout = async () => {
    return storeLogout();
  };

  return { user, session, login, register, logout, isAuthenticated, isLoading };
};

export default useAuth;
